import {
  Allocations,
  MVF,
  mvfProfileFromTrancheProfile,
  Tranche,
  TrancheProfile,
} from "@lib/tranche";
import { getDollars, getFullness, getMarginalValue } from "algorithm/mvfs";

// TODO: have these entirely replaced getFDV, getLDT, and getFullness? (they can in some places, but not all)
export function getFDVFromTranches(
  tranches: Tranche[],
  evaluableId: string,
): number | null {
  let fdv: number | null = null;
  for (const tranche of tranches) {
    if (fdv == null && !tranche.allocations[evaluableId]) {
      continue;
    }

    if (fdv == null) {
      fdv = 0;
    }

    fdv += tranche.height;
  }

  return fdv;
}

export function getLDTFromTranches(
  tranches: Tranche[],
  evaluableId: string,
): number | null {
  let ldt: number | null = null;
  for (const tranche of tranches) {
    if (ldt == null && !tranche.allocations[evaluableId]) {
      continue;
    }

    if (ldt == null) {
      ldt = 0;
    }

    ldt += tranche.allocations[evaluableId]?.amount ?? 0;
  }

  return ldt;
}

export function getFullnessFromTranches(
  tranches: Tranche[],
  evaluableId: string,
): number | null {
  // TODO: is it possible to calculate this directly without first
  // converting to an MVF?
  const mvfs = mvfProfileFromTrancheProfile(tranches);
  if (!mvfs[evaluableId]) {
    return null;
  }

  return getFullness(mvfs[evaluableId]);
}

export function fdvFromMVF(mvf: MVF): number {
  return mvf[0].value;
}

export function ldtFromMVF(mvf: MVF): number {
  return mvf[mvf.length - 1].dollar;
}

export function dollarsFromMVF(mvf: MVF, value: number): number {
  return getDollars(value, mvf, 1e12)[0];
}

export function valueFromMVF(mvf: MVF, dollar: number): number {
  return getMarginalValue(dollar, mvf);
}

export function cumulatizeTrancheProfile(
  trancheProfile: TrancheProfile,
): TrancheProfile {
  const cumulativeAllocations: { [evaluableId: string]: number } = {};

  return trancheProfile.map((tranche) => {
    const newAllocations: Allocations = Object.fromEntries(
      Object.entries(cumulativeAllocations).map(([evaluableId, amount]) => [
        evaluableId,
        { amount, bottomPlaced: false },
      ]),
    );

    for (const evaluableId in tranche.allocations) {
      const allocation = tranche.allocations[evaluableId];
      const prevAmount = cumulativeAllocations[evaluableId] || 0;

      // Update the cumulative amount
      const newAmount = prevAmount + allocation.amount;

      // Store the new cumulative value
      cumulativeAllocations[evaluableId] = newAmount;

      // Create the new allocation object with the cumulative amount
      newAllocations[evaluableId] = {
        amount: newAmount,
        bottomPlaced: allocation.bottomPlaced, // Keep the original bottomPlaced value
      };
    }

    return {
      ...tranche,
      allocations: newAllocations, // Assign the new cumulative allocations
    };
  });
}
